module.exports = __webpack_public_path__ + "static/media/L.94ce8485.jpg";